<template>
  <v-card class="pa-12 text-center">
    <h1 class="text-h4 font-weight-medium mb-3">
      {{ $t('comingSoon') }}
    </h1>
    <p class="text-body-1 text--secondary mb-0" v-html="description"></p>
  </v-card>
</template>

<script>
export default {
  computed: {
    description() {
      const key = this.$route.meta.comingSoonKey
      if (key && this.$te(`comingSoonDescriptions.${key}`)) {
        return this.$t(`comingSoonDescriptions.${key}`)
      }
      return this.$t('comingSoonDefault')
    },
  },
}
</script>
